import TitleText from './title'
import ButtonText from './button'
import ScrollSettings from './scroll'

export * from './types'

export { TitleText, ButtonText, ScrollSettings }
